// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  CanonicalAddress,
} from "./types";

export default {
  googlePlaceId: __t.string(),
  googlePlacePhotoName: __t.option(__t.string()),
  name: __t.string(),
  get businessAddress() {
    return CanonicalAddress;
  },
  businessCategory: __t.string(),
  businessType: __t.string(),
  websiteUrl: __t.string(),
};
